export const state = {
  modalViewAddress: false,
  addresses: [],
  address: {}
};

export default {};
